"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = void 0;

/**
 * Returns width and height of spinner based on size
 * @param props
 */
var getSize = function getSize(props) {
  var base = {
    width: 25,
    height: 6
  };

  switch (props.size) {
    case "small":
      return {
        width: base.width * 0.5,
        height: base.height * 0.5
      };

    case "medium":
      return {
        width: base.width * 0.8,
        height: base.height * 0.8
      };

    case "large":
      return {
        width: base.width,
        height: base.height
      };

    default:
      return {
        width: props.width,
        height: props.height
      };
  }
};

exports.getSize = getSize;
//# sourceMappingURL=Spinner.shared.js.map